// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';

import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getFundsAveraging = (
  policyId: string,
  fundId: number,
  period: number,
  currencyId: number,
) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const params = { period, fundId: fundId < 0 ? null : fundId, currencyId };

  return backendAxios.get(`/policies/${policyId}/funds/account-value`, { params });
};

export default getFundsAveraging;
